module.exports = "/assets/8d90cddc59422caa8fb227708d8422fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/H2.png
// module id = 2550
// module chunks = 0